import { createContext } from "react";
import uuidv4 from 'uuid/v4'

export interface SuccessMessageState {
    successMessage: string;
    successMessageShown: boolean;
    successMessageId: string;
    showSuccessMessage?: (successMessage: string) => void;
    hideSuccessMessage?: () => void
}

export const defaultSuccessMessageState: SuccessMessageState = {
         successMessage: "",
         successMessageShown: false,
         successMessageId: uuidv4()
       };

const SuccessMessageContext = createContext(defaultSuccessMessageState);
export default SuccessMessageContext